module.exports = __webpack_public_path__ + "img/tempo_4.7d81d83d.png";